import { render, staticRenderFns } from "./appVersion.vue?vue&type=template&id=141ccbb0&scoped=true"
import script from "./appVersion.vue?vue&type=script&lang=ts"
export * from "./appVersion.vue?vue&type=script&lang=ts"
import style0 from "./appVersion.vue?vue&type=style&index=0&id=141ccbb0&prod&lang=scss"
import style1 from "./appVersion.vue?vue&type=style&index=1&id=141ccbb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ccbb0",
  null
  
)

export default component.exports